import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';


import { Autoplay } from 'swiper/modules';

export default function SliderHomeBanner() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                }}


                modules={[Autoplay]}
                className="mySwiper"
                style={{ overflow: "hidden", marginTop: "" }}
            >


                <SwiperSlide >
                    <div className="">
                        <img src="./assets/yog/banner_0.webp" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>
                <SwiperSlide >
                    <div className="">
                        <img src="./assets/yog/banner_1.webp" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>
                <SwiperSlide >
                    <div className="">
                        <img src="./assets/yog/banner_2.webp" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>
                <SwiperSlide >
                    <div className="">
                        <img src="./assets/yog/banner_3.webp" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>


                {/* <SwiperSlide>
                    <div className="owl-item cloned" style={{ width: 1351 }}>
                        <div className="hero-single" style={{ backgroundImage: 'url(assets/img/hero/slider-2.jpg)' }}>
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-md-12 col-lg-6">
                                        <div className="hero-content">
                                            <h6 className="hero-sub-title animated fadeInUp" data-animation="fadeInUp" data-delay=".25s" style={{ animationDelay: '0.25s' }}>
                                                <i className="far fa-solar-panel" /> Yogesh solar energy
                                            </h6>
                                            <h1 className="hero-title animated fadeInRight" data-animation="fadeInRight" data-delay=".50s" style={{ animationDelay: '0.5s' }}>
                                                Brighten Your   &amp; <span>Life with</span> Yogesh solar energy
                                            </h1>
                                            <p data-animation="fadeInLeft" data-delay=".75s" className="animated fadeInLeft" style={{ animationDelay: '0.75s' }}>
                                                We use premium materials, expert craftsmanship, and advanced technology to ensure durable, efficient, and top-performing solar solutions tailored to your energy needs.
                                            </p>
                                            <div className="hero-btn animated fadeInUp" data-animation="fadeInUp" data-delay="1s" style={{ animationDelay: '1s' }}>
                                                <a to="about.html" className="theme-btn">About More<i className="fas fa-arrow-right" /></a>
                                                <a to="contact.html" className="theme-btn2">Contact Now<i className="fas fa-arrow-right" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" style={{ width: 1351 }}><div className="hero-single" style={{ backgroundImage: 'url(assets/img/hero/slider-3.jpg)' }}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-12 col-lg-6">
                                    <div className="hero-content">
                                        <h6 className="hero-sub-title" data-animation="fadeInUp" data-delay=".25s">
                                            <i className="far fa-solar-panel" /> Yogesh solar energy
                                        </h6>
                                        <h1 className="hero-title" data-animation="fadeInRight" data-delay=".50s">
                                            Your Gateway  &amp; <span>to Solar</span> Energy Excellence
                                        </h1>
                                        <p data-animation="fadeInLeft" data-delay=".75s">
                                            Harness the Power of the Sun with Yogesh solar energy. We are dedicated to providing cutting-edge solar solutions to transform your energy consumption.
                                        </p>
                                        <div className="hero-btn" data-animation="fadeInUp" data-delay="1s">
                                            <a to="about.html" className="theme-btn">About More<i className="fas fa-arrow-right" /></a>
                                            <a to="contact.html" className="theme-btn2">Contact Now<i className="fas fa-arrow-right" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item" style={{ width: 1351 }}><div className="hero-single" style={{ backgroundImage: 'url(assets/img/hero/slider-1.jpg)' }}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-12 col-lg-6">
                                    <div className="hero-content">
                                        <h6 className="hero-sub-title" data-animation="fadeInUp" data-delay=".25s" style={{ animationDelay: '0.25s' }}>
                                            <i className="far fa-solar-panel" /> Yogesh solar energy
                                        </h6>
                                        <h1 className="hero-title" data-animation="fadeInRight" data-delay=".50s" style={{ animationDelay: '0.5s' }}>
                                            End-to-End   &amp; <span>Solar</span> Solutions
                                        </h1>
                                        <p data-animation="fadeInLeft" data-delay=".75s" className style={{ animationDelay: '0.75s' }}>
                                            Our services encompass project feasibility assessment, review and preparation of system design and engineering, permitting and regulatory compliance support, procurement, construction management, and ongoing maint
                                        </p>
                                        <div className="hero-btn" data-animation="fadeInUp" data-delay="1s" style={{ animationDelay: '1s' }}>
                                            <a to="about.html" className="theme-btn">About More<i className="fas fa-arrow-right" /></a>
                                            <a to="contact.html" className="theme-btn2">Contact Now<i className="fas fa-arrow-right" /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </SwiperSlide> */}



            </Swiper>
        </>
    );
}
